'use strict';

module Patersons {

    export interface PlaceOrderRequestScope extends ng.IScope {
        orderRequestForm: ng.IFormController;
        parentController: AbstractController;
        portfolio: Array<Account>;
        selectedAccount: Account;
        selectedAccountId: string;
        order: OrderRequest;
        events: Patersons.PlaceOrderRequestViewCtrl;
        date: Date;
        isLoading: boolean;
        errorHandler: any;
        isSubmitted: boolean;
    }

    export class PlaceOrderRequestViewCtrl extends AbstractController {
        scope: Patersons.PlaceOrderRequestScope;
        portfolioService: Patersons.PortfolioService;

        static $inject = ['$scope', '$log', '$location', '$window', '$state', '$stateParams', '$http', '$rootScope', 'portfolioService'];

        constructor($scope, $log, $location, $window, $state, $stateParams, $http, $rootScope, placeOrderRequestService, portfolioService) {
            super($scope, $log, $location, $window, $state, $stateParams, $http, $rootScope);
            this.scope = $scope;
            this.portfolioService = portfolioService;
            this.scope.parentController = this;
            this.scope.events = this;
            this.scope.isSubmitted = false;
            var accountId = $stateParams.accountId;
            this.clearOrderRequestForm();
        }

        placeOrderRequest() {
            this.scope.$broadcast('show-errors-check-validity');

            if (this.scope.orderRequestForm.$invalid) {
                return;
            }
            var promise: ng.IHttpPromise<any> = this.portfolioService.placeOrderRequest(this.scope.order);
            promise.then((result) => {
                this.scope.isSubmitted = true;
                return;
            },
                (reason) => {
                    this.scope.errorHandler = reason.data;
                });
        }

        viewOrderRequests() {
            this.location.path('/viewOrderRequests');
        }

        clearOrderRequestForm() {
            this.scope.order = new OrderRequest();
        }
    }
}
